const LENGTH_OF_CHECK_INTERVAL = 1000 * 60 * 2; // 2 minutes
const TIMERS_SHOULD_RUN = false;

export { LENGTH_OF_CHECK_INTERVAL, TIMERS_SHOULD_RUN };
